(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("noticebar", [], factory);
	else if(typeof exports === 'object')
		exports["noticebar"] = factory();
	else
		root["noticebar"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 